import React from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Label,
  Spinner,
  UncontrolledTooltip,
  ModalBody,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Modal from "react-bootstrap/Modal"
import { useState } from "react"
import { Formik, Form, Field, ErrorMessage } from "lib/formik"
import { addBannerSetSchema } from "components/Common/validation"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import {
  addBanner,
  deleteBanner,
  deleteSlide,
  getAllBanners,
  getBannerDetails,
  updateBanner,
  updateBannerStatus,
  updateSlideStatus,
} from "store/actions/bannerAction"
import {
  addOfferBanner,
  deleteOfferBanner,
  deleteOfferSlide,
  getAllOfferBanners,
  getOfferBannerDetails,
  updateOfferBanner,
  updateOfferBannerStatus,
  updateOfferSlideStatus,
} from "store/actions/offerBannerAction"
import { SLIDING_BANNER_CONFIG } from "constants/bannerModuleConfig"
import { useEffect } from "react"
import DeleteModal from "components/Common/DeleteModal"
import Switch from "components/Shared/Switch"
import { useLocation, useNavigate } from "react-router-dom"
import { showAlert } from "store/reducers/alertReducer"
import isPermissionEnabled from "common/isPermissionEnabled"
import { ShimmerThumbnail } from "react-shimmer-effects"
import Paginations from "components/Common/Paginations"
import { useTranslation } from "react-i18next"
import { getCountryList } from "store/actions/countriesAction"
import Select from "components/Shared/TranslatedSelect"
import Filters from "components/Common/Filters"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import TextError from "components/Shared/TextError"
// import { getBrandList } from "store/actions/brandsAction"
import { useBrandOptions } from "hooks"
import useCrossModuleFilterPermissions from "hooks/useCrossModuleFilterPermissions"

const initialValues = { name: "", nameAr: "", countryCode: "", brand: "" }

const Banners = ({ moduleConfig = SLIDING_BANNER_CONFIG }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const isOfferModule = moduleConfig.reduxNamespace === "OfferBanners"
  const bannerApi = isOfferModule
    ? {
        getAll: getAllOfferBanners,
        add: addOfferBanner,
        delete: deleteOfferBanner,
        getDetails: getOfferBannerDetails,
        update: updateOfferBanner,
        updateStatus: updateOfferBannerStatus,
        deleteSlide: deleteOfferSlide,
        updateSlideStatus: updateOfferSlideStatus,
      }
    : {
        getAll: getAllBanners,
        add: addBanner,
        delete: deleteBanner,
        getDetails: getBannerDetails,
        update: updateBanner,
        updateStatus: updateBannerStatus,
        deleteSlide: deleteSlide,
        updateSlideStatus: updateSlideStatus,
      }

  document.title = t(moduleConfig.documentTitleKey)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { countryList } = useSelector(state => state.Countries)
  // const { brandList } = useSelector(state => state.Brands)
  const { allowedBrands } = useBrandOptions()

  const {
    loading,
    isLoading,
    isUpdating,
    actionType,
    totalCount,
    totalPages,
    itemsPerPage,
    currentPage,
    bannerLists,
    bannerDetails,
  } = useSelector(state =>
    isOfferModule ? state.OfferBanners : state.Banners
  )

  const { userRole, accountType } = useSelector(state => state.Login)
  const { canFilterByCountry } = useCrossModuleFilterPermissions()
  const location = useLocation()

  const [formValues, setFormValues] = useState(initialValues)
  const searchParams = new URLSearchParams(location.search)
  const [show, setShow] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [modalType, setModalType] = useState(null)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedSlideId, setSelectedSlideId] = useState(null)
  const [selectedSlideBannerId, setSelectedSlideBannerId] = useState(null)
  const [showSlideDeleteModal, setShowSlideDeleteModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [isApiCalled, setIsApiCalled] = useState(false)
  const [showStatusModal, setShowStatusModal] = useState(false)
  const [pendingStatusData, setPendingStatusData] = useState(null)

  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    countryCode: [],
  })

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  useEffect(() => {
    fetchCountryList()
  }, [])

  const fetchCountryList = () => {
    if (!canFilterByCountry) return
    dispatch(getCountryList())
    // dispatch(getBrandList())
  }

  const brandOptions =
    allowedBrands?.map(obj => ({
      value: obj._id,
      label: obj.brandName,
    })) || []

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const { permissionCategoryId, permissions } = moduleConfig
    const isPermissionList = isPermissionEnabled(
      userRole,
      permissionCategoryId,
      permissions.view
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      permissionCategoryId,
      permissions.add,
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      permissionCategoryId,
      permissions.update
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      permissionCategoryId,
      permissions.delete,
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  const handleClose = () => {
    setShow(false)
    setFormValues({
      name: "",
      nameAr: "",
      countryCode: "",
    })
  }
  const handleShow = () => setShow(true)

  useEffect(() => {
    fetchBanners()
  }, [])

  const fetchBanners = () => {
    const { status, sortOrder } = selectedFilters

    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: status,
      orderBy: sortOrder,
      keyword: "",
      // countryCode: ["IN"],
    }
    dispatch(bannerApi.getAll(payload))
    setIsApiCalled(true)
  }

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 2 },
        { label: t("Active"), value: 1 },
        { label: t("Deactive"), value: 0 },
      ],
      placeholder: t("All"),
    },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
    {
      name: "countryCode",
      type: "multiSelect",
      options: [
        // { label: "All", value: "" },
        ...countryList.map(item => ({
          label: language === "sa" ? item.nameAr : item.name,
          value: item.countryCode,
        })),
      ],
      placeholder: t("Select Countries"),
    },
  ]

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleAddBannerSet = (values, { resetForm }) => {
    const { name, nameAr, countryCode, brand } = values
    const updatedCountryCode = countryCode.value

    if (modalType === "ADD_BANNER") {
      const payload = {
        name,
        nameAr,
        countryCode: updatedCountryCode,
        brand: brand?.value,
      }
      dispatch(bannerApi.add({ ...payload, handleClose }))
    } else if (modalType === "EDIT_BANNER") {
      const payload = {
        id: selectedId,
        name,
        nameAr,
        countryCode: updatedCountryCode,
        brand: brand?.value,
      }
      dispatch(bannerApi.update({ ...payload, handleClose }))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const handleEditBanner = id => {
    setModalType("EDIT_BANNER")
    handleShow()
    const payload = {
      id,
    }
    dispatch(bannerApi.getDetails(payload))
  }

  useEffect(() => {
    if (
      actionType === "GET_BANNER_DETAILS_SUCCESS" &&
      !isLoading &&
      modalType === "EDIT_BANNER"
    ) {
      const { name, nameAr, countryCode, brand } = bannerDetails
      let updatedCountryCode = {}
      let updatedBrand = {}
      const matchedCountry = countryList.find(
        item => item.countryCode === countryCode
      )
      if (matchedCountry) {
        updatedCountryCode = {
          label:
            language === "sa" ? matchedCountry.nameAr : matchedCountry.name,
          value: matchedCountry.countryCode,
        }
      } else {
        updatedCountryCode = {}
      }

      const matchedbrand = brandOptions.find(item => item?.value == brand)
      if (matchedbrand) {
        updatedBrand = {
          label: matchedbrand?.label,
          value: matchedbrand?.value,
        }
      } else {
        updatedBrand = {}
      }

      setFormValues(prevValues => ({
        ...prevValues,
        name,
        nameAr,
        countryCode: updatedCountryCode,
        brand: updatedBrand,
      }))
    }
  }, [
    actionType,
    bannerDetails,
    isLoading,
    modalType,
    countryList,
    language,
  ])

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // for delete
    }
    dispatch(bannerApi.delete({ ...payload, setShowDeleteModal }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleBannerStatus = (id, status) => {
    setSelectedId(id)
    const payload = {
      id,
      status: status === 1 ? "0" : "1", //deactive 1 active
    }
    dispatch(bannerApi.updateStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleSlideStatusClick = (id, status, bannerId) => {
    setSelectedSlideId(id)
    const payload = {
      id,
      status: status === 1 ? "0" : "1", //deactive 1 active
    }
    dispatch(bannerApi.updateSlideStatus({ ...payload, bannerId }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleSlideDelete = () => {
    const payload = {
      id: selectedSlideId,
      status: "2", // for delete
    }
    dispatch(
      bannerApi.deleteSlide({
        ...payload,
        selectedSlideBannerId,
        setShowSlideDeleteModal,
      })
    )
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const getApiCall = (page = 1) => {
    const { status, sortOrder, countryCode } = selectedFilters
    const updatedCode = countryCode?.map(item => item.value) || []

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      countryCode: updatedCode,
    }

    return dispatch(bannerApi.getAll(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`${moduleConfig.basePath}?page=${page}`)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const handleSearch = () => {
    getApiCall(1)
  }

  const onPageChange = page => {
    getApiCall(page)
  }

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters])

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 2,
      orderBy: 1,
      keyword: "",
      countryCode: [],
    }
    dispatch(bannerApi.getAll(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`${moduleConfig.basePath}?page=${1}`)
        }
      })
      .catch(error => {})
    setSelectedFilters({ status: 2, sortOrder: 1, countryCode: [] })
    setSearchTerm("")
  }

  return (
    <div className="page-content banners_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Col md={12}>
          <Card>
            <DataExportDropdown
              cardTitle={t(moduleConfig.listTitleKey)}
              isAddBtn={loading ? false : usersPermissions.create}
              addBtnText={t("Add Banner Set")}
              onAddBtnClick={() => {
                handleShow()
                setModalType("ADD_BANNER")
              }}
            />
            <CardBody>
              <Filters
                filters={filters}
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                handleFilterChange={handleFilterChange}
                onReset={handleReset}
                handleSearch={handleSearch}
                handleReset={handleReset}
                selectedFilters={selectedFilters}
                searchBy={t("Name")}
              />
            </CardBody>
          </Card>
        </Col>
        <Row>
          {loading ? (
            <>
              <ShimmerThumbnail height={300} rounded />
              <div className="mt-3"></div>
              <ShimmerThumbnail height={300} rounded />
            </>
          ) : bannerLists.length === 0 ? (
            <p className="text-center my-2">{t("No banners found")}</p>
          ) : (
            bannerLists.map(
              ({ _id, name, nameAr, status, slides, countryCode }, index) => (
                <Col md={12} key={_id}>
                  <Card style={{ height: "93.5%" }}>
                    <CardBody>
                      <CardTitle className="mb-3">
                        <div className="d-flex justify-content-start align-items-center">
                          <span className="me-3">
                            {language === "sa" ? nameAr : name}
                          </span>
                          {usersPermissions.edit && (
                            <Switch
                              isChecked={status}
                              onClickHandler={() => {
                                setPendingStatusData({
                                  type: "banner",
                                  id: _id,
                                  status,
                                })
                                setShowStatusModal(true)
                              }}
                              disabled={_id === selectedId && isUpdating}
                            />
                          )}
                          {usersPermissions.edit && (
                            <>
                              <i
                                id={`edittooltip_${_id}`}
                                onClick={() => {
                                  handleEditBanner(_id)
                                  setSelectedId(_id)
                                }}
                                className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={`edittooltip_${_id}`}
                              >
                                {t("Edit")}
                              </UncontrolledTooltip>
                            </>
                          )}
                          {usersPermissions.delete && (
                            <>
                              <i
                                id={`deletetooltip_${_id}`}
                                onClick={() => {
                                  setItemIdToDelete(_id)
                                  setShowDeleteModal(true)
                                }}
                                className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                style={{ color: "#FD5F62" }}
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={`deletetooltip_${_id}`}
                              >
                                {t("Delete")}
                              </UncontrolledTooltip>
                            </>
                          )}
                        </div>
                      </CardTitle>
                      <div className="mb-4">
                        {usersPermissions.create && (
                          <Button
                            color="success"
                            className="mx-1"
                            onClick={() =>
                              navigate(
                                `${moduleConfig.basePath}/${_id}/slides/add?countryCode=${countryCode}`
                              )
                            }
                          >
                            {t("Add Slide")}
                          </Button>
                        )}
                      </div>
                      <div className="slides">
                        {slides &&
                          slides.map(
                            ({
                              _id,
                              imageUrl,
                              imageUrlAr,
                              status,
                              bannerGroup,
                            }) => (
                              <div
                                className="position-relative single_banner"
                                key={_id}
                              >
                                <img
                                  src={
                                    language === "sa" ? imageUrlAr : imageUrl
                                  }
                                  alt=""
                                  className="slide_img cursor-pointer rounded pt-1"
                                  onClick={() => {
                                    navigate(
                                      `${moduleConfig.basePath}/${bannerGroup}/slides/edit?id=${_id}&countryCode=${countryCode}`
                                    )
                                  }}
                                />
                                <div className="d-flex justify-content-between align-items-center px-1 mt-2">
                                  {usersPermissions.edit && (
                                    <div>
                                      <Switch
                                        isChecked={status}
                                        onClickHandler={() => {
                                          setPendingStatusData({
                                            type: "slide",
                                            id: _id,
                                            status,
                                            bannerId: bannerGroup,
                                          })
                                          setShowStatusModal(true)
                                        }}
                                        disabled={
                                          _id === selectedSlideId && isUpdating
                                        }
                                      />
                                    </div>
                                  )}
                                  {usersPermissions.delete && (
                                    <button
                                      className="transparent_btn"
                                      onClick={() => {
                                        setShowSlideDeleteModal(true)
                                        setSelectedSlideId(_id)
                                        setSelectedSlideBannerId(bannerGroup)
                                      }}
                                    >
                                      <i className="bx bx-trash-alt delete_icon"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )
            )
          )}
        </Row>
        {!loading && bannerLists.length > 0 && (
          <Row>
            <Card>
              <CardBody>
                <Paginations
                  data={bannerLists}
                  itemsPerPage={itemsPerPage}
                  onPageChange={onPageChange}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                />
              </CardBody>
            </Card>
          </Row>
        )}
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "ADD_BANNER" ? t("Add") : t("Save")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {modalType === "EDIT_BANNER" && isLoading ? (
            // <p>Loading</p>
            <div className="d-flex justify-content-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <Formik
              initialValues={formValues}
              enableReinitialize={true}
              validationSchema={addBannerSetSchema}
              onSubmit={handleAddBannerSet}
            >
              {({ values, errors, touched, setFieldValue }) => (
                <Form>
                  <div className="form_field">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span>{" "}
                      {t("Name(English)")}
                    </Label>
                    <Field
                      name="name"
                      type="text"
                      placeholder={t("Name(English)")}
                      className={`form-control ${
                        touched.name && errors.name ? "is-invalid" : ""
                      }`}
                    />
                    <TextError name={"name"} />
                  </div>
                  <div className="form_field">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span>
                      {t("Name(عربي)")}
                    </Label>
                    <Field
                      name="nameAr"
                      type="text"
                      style={{ direction: "rtl" }}
                      placeholder={t("Name(عربي)")}
                      className={`form-control ${
                        touched.nameAr && errors.nameAr ? "is-invalid" : ""
                      }`}
                    />
                    <TextError name={"nameAr"} />
                  </div>
                  <div className="">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span> {t("Select Brand")}
                    </Label>
                    <Select
                      value={values.brand}
                      onChange={item => {
                        setFieldValue("brand", item)
                      }}
                      options={brandOptions}
                      className={`select2-selection ${
                        touched.brand && errors.brand
                          ? "danger_color_border"
                          : ""
                      } `}
                      placeholder={t("Select Brand")}
                    />
                    <TextError name={"brand"} />
                  </div>
                  <div className="">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span>{" "}
                      {t("Select Country")}
                    </Label>
                    <Select
                      value={
                        values.countryCode?.value
                          ? {
                              value: values.countryCode.value,
                              label: (() => {
                                const matched = countryList?.find(
                                  item =>
                                    item.countryCode ===
                                    values.countryCode.value
                                )
                                if (!matched) return values.countryCode.label
                                return language === "sa"
                                  ? matched.nameAr
                                  : matched.name
                              })(),
                            }
                          : values.countryCode
                      }
                      onChange={item => {
                        setFieldValue("countryCode", item)
                      }}
                      options={countryList?.map(item => ({
                        label: language === "sa" ? item.nameAr : item.name,
                        value: item.countryCode,
                      }))}
                      className={`select2-selection ${
                        touched.countryCode && errors.countryCode
                          ? "danger_color_border"
                          : ""
                      } `}
                      placeholder={t("Select Country")}
                    />
                    <TextError name={"countryCode"} />
                  </div>
                  <Button
                    color="success"
                    type="submit"
                    className="my-2 mt-4 ms-auto d-block"
                    disabled={isLoading || isUpdating}
                  >
                    {modalType === "ADD_BANNER" ? t("Add") : t("Save")}
                  </Button>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
        {/* )} */}
        <Modal.Footer></Modal.Footer>
      </Modal>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        isLoading={isLoading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this Banner?")}
      />
      <DeleteModal
        show={showSlideDeleteModal}
        onDeleteClick={handleSlideDelete}
        onCloseClick={() => {
          setShowSlideDeleteModal(false)
          setSelectedSlideId(null)
          setSelectedSlideBannerId(null)
        }}
        isLoading={isLoading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this Slide?")}
      />
      <Modal
        show={showStatusModal}
        onHide={() => setShowStatusModal(false)}
        centered
      >
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={() => setShowStatusModal(false)}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="bx bx bx-copy"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">
            {t("Are you sure you want to update the status?")}
          </p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowStatusModal(false)}
            >
              {t("Close")}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                if (pendingStatusData?.type === "banner") {
                  handleBannerStatus(
                    pendingStatusData.id,
                    pendingStatusData.status
                  )
                } else if (pendingStatusData?.type === "slide") {
                  handleSlideStatusClick(
                    pendingStatusData.id,
                    pendingStatusData.status,
                    pendingStatusData.bannerId
                  )
                }
                setShowStatusModal(false)
              }}
              disabled={isLoading}
            >
              {t("Yes")}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default Banners
